import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

const admin = lazy(() => import("./AdminParent"));

const ADMIN_ROUTES: RouteObject[] = [
  {
    path: "/private/admin",
    element: React.createElement(admin),
  },
];

export default ADMIN_ROUTES;
